import React from 'react';
import styled from 'styled-components';
import { string, element, bool } from 'prop-types';
import Wrapper from '../Wrapper';
import Text from '../Text/Text';

const TooltipContainer = styled.div`
  background: ${({ theme }) => theme.colors.primaryWhite};
  border: 1px solid ${({ theme }) => theme.colors.greyLight};
  min-width: 236px;
  width: fit-content;
  border-radius: 6px;
  box-sizing: border-box;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
  padding: 16px;
  position: absolute;
  z-index: ${props => (props.atTop ? '9999' : '1')};
  ${props =>
    props.atTop ? 'bottom: calc(100% + 5px);' : 'top: calc(100% + 5px);'}
  left: 50%;
  visibility: hidden;
  transform: translate(-50%);

  &:after {
    content: '';
    display: block;
    position: absolute;
    ${props => (props.atTop ? 'bottom: -7px;' : 'top: -7px;')}
    right: calc(50% - 5px);
    width: 12px;
    height: 12px;
    background: ${({ theme }) => theme.colors.primaryWhite};
    border-right: 1px solid ${({ theme }) => theme.colors.greyLight};
    ${props => (props.atTop ? 'border-bottom' : 'border-top')}: 1px solid
      ${({ theme }) => theme.colors.greyLight};
    transform: ${props => (props.atTop ? 'rotate(45deg);' : 'rotate(-45deg);')};
  }
`;

const TooltipWrapper = styled(Wrapper)`
  position: relative;
  display: inline-flex;
  &:hover {
    ${TooltipContainer} {
      visibility: visible;
    }
  }
`;

const Tooltip = ({ children, content, atTop, ...restProps }) => {
  return (
    <TooltipWrapper {...restProps}>
      <TooltipContainer atTop={atTop}>
        <Text
          fontSize="14px"
          fontWeight={400}
          lineHeight="18px"
          color="greyDarker"
        >
          {content}
        </Text>
      </TooltipContainer>
      {children}
    </TooltipWrapper>
  );
};

Tooltip.propTypes = {
  children: element.isRequired,
  content: string.isRequired,
  atTop: bool,
};

export default Tooltip;
